import { createContext, type RefObject } from "react";
import type { CuadraChatClient } from "../lib/cuadraChatClient";

export interface ArtifactLoaderContextValue {
  client: CuadraChatClient;
  enableArtifacts: boolean;
  /** Set by ArtifactLoaderGate so the adapter can call refreshAfterStream on stream end */
  refreshCallbackRef: RefObject<((chatId: string) => void) | null>;
  /** Set when the first stream chunk arrives (onChatCreated). Used to resolve chatId before thread map is updated. */
  currentChatIdRef: RefObject<string | null>;
  /** Stable ref to the onArtifactComplete callback so refreshAfterStream can fire it as a fallback. */
  onArtifactCompleteRef?: RefObject<
    ((chatId: string, artifactId?: string) => void) | undefined
  >;
  /** After list load, open this artifact id or identifier (e.g. from host URL `?artifact=`). */
  initialOpenArtifactId?: string | null;
  /**
   * singleChat: resolved server thread id (URL, bg-reload latch, or runtime latch).
   * Used so `useArtifactLoader` can clear the singleton artifact store on true
   * "blank composer" without wiping during transient null while a thread id
   * still exists.
   */
  resolvedServerThreadId?: string | undefined;
}

export const ArtifactLoaderContext =
  createContext<ArtifactLoaderContextValue | null>(null);
